// extracted by mini-css-extract-plugin
module.exports = {"pressReleaseMultipleColumnContent":"PressReleaseArticle_pressReleaseMultipleColumnContent__l4si8"};